export const fullName = (user) => `${(user === null || user === void 0 ? void 0 : user.firstName) || ''} ${(user === null || user === void 0 ? void 0 : user.lastName) || ''}`.trim();
export const twoLettersInitials = (name) => (name !== null && name !== void 0 ? name : '')
    .split(/\s+/)
    .filter(part => part)
    .map(part => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
//# sourceMappingURL=user.js.map